module.exports = __webpack_public_path__ + "static/media/EV7A2177-122.25f4fb22.webp";